import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * Discovered social profiles for cross-platform identity resolution.
 */
@Entity('recon_social_profiles')
@Index('idx_recon_social_profiles_unique', ['platformId', 'platformUserId'], {
	unique: true,
})
@Index('idx_recon_social_profiles_handle', ['platformHandle'])
export class ReconSocialProfileEntity extends BaseEntity {
	@Column('varchar', { name: 'platform_id', length: 50 })
	public platformId!: string;

	@Column('varchar', { name: 'platform_user_id', length: 255 })
	public platformUserId!: string;

	@Column('varchar', { name: 'platform_handle', length: 255, nullable: true })
	public platformHandle!: string | null;

	@Column('varchar', {
		name: 'platform_display_name',
		length: 255,
		nullable: true,
	})
	public platformDisplayName!: string | null;

	@Column('text', { name: 'platform_profile_url', nullable: true })
	public platformProfileUrl!: string | null;

	@Column('text', { name: 'platform_avatar_url', nullable: true })
	public platformAvatarUrl!: string | null;

	@Column('text', { name: 'bio', nullable: true })
	public bio!: string | null;

	@Column('varchar', { name: 'location', length: 255, nullable: true })
	public location!: string | null;

	@Column('text', { name: 'website_url', nullable: true })
	public websiteUrl!: string | null;

	@Column('int', { name: 'follower_count', nullable: true, unsigned: true })
	public followerCount!: number | null;

	@Column('int', { name: 'following_count', nullable: true, unsigned: true })
	public followingCount!: number | null;

	// Professional info (if available from bio parsing or enrichment)
	@Column('varchar', { name: 'current_title', length: 255, nullable: true })
	public currentTitle!: string | null;

	@Column('varchar', { name: 'current_company', length: 255, nullable: true })
	public currentCompany!: string | null;

	@Column('varchar', { name: 'industry', length: 255, nullable: true })
	public industry!: string | null;

	// Enrichment metadata
	@Column('datetime', { name: 'enriched_at', nullable: true })
	public enrichedAt!: Date | null;

	@Column('varchar', { name: 'enrichment_source', length: 100, nullable: true })
	public enrichmentSource!: string | null;
}
